// eslint-disable-next-line import/prefer-default-export
export const INITIATE_INSTRUMENTS_LOAD = 'instruments/INITIATE_INSTRUMENTS_LOAD';
export const INSTRUMENTS_MODULE_LOADED = 'instruments/INSTRUMENTS_MODULE_LOADED';
